import { DhlText as NewText } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for Text component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const Text = (props) => {
  const { children, size, isParagraph, ...rest } = props;

  // Map old props to new props
  const newProps = {
    ...rest,
    size: size ?? "md",
    isParagraph: isParagraph ?? false,
  };

  return <NewText {...newProps}>{children}</NewText>;
};

Text.propTypes = {
  children: PropTypes.node,
  size: PropTypes.string,
  isParagraph: PropTypes.bool,
};

Text.TINY = "2xs";
Text.SMALL = "xs";
Text.REGULAR = "sm";
Text.MEDIUM = "md";
Text.LARGE = "xl";
Text.XLARGE = "2xl";
Text.XXLARGE = "3xl";

export default Text;
